module.exports = __webpack_public_path__ + "home/en-US/js/home-tabs/images/academy-tab-inactive-dt-274843ee3247be1e2bcd02bc1967eaca.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/home-tabs/images/academy-tab-inactive-dt.png
// module id = m1OX
// module chunks = 0